import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { referrerService } from "@/modules/contacts/features/referrer/store/services/referrer-service";
import { REFERRER_SERVICE_TAG } from "@/modules/contacts/features/referrer/utils/referrer-service-tags";
import { REFERRER_ANALYTIC_EVENTS } from "@/modules/contacts/features/referrer/utils/referrer-analytic-events";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";

const deleteReferrer = referrerService.injectEndpoints({
  endpoints: builder => ({
    deleteReferrer: builder.mutation({
      query(id) {
        return {
          url: `referrers/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: REFERRER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(REFERRER_ANALYTIC_EVENTS.REFERRER_DELETED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Referrer has been deleted!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteReferrerMutation } = deleteReferrer;

